export enum ProductComponentType {
  Workspaces = 'workspaces',
  Decks = 'decks',
  StudySchedule = 'studyschedule',
  Videos = 'videos',
  Flashcards = 'flashcards',
  Qbank = 'qbank',
  Analytics = 'analytics',
  Playlists = 'playlists',
  Notes = 'notes',
  VideoTopics = 'VideoTopics',
}

export type ProductComponent = {
  title: string;
  order: number;
  type: ProductComponentType;
  url: string;
  theme?: string;
  inEnglish?: boolean;
};

export const productComponents: { [index: string]: ProductComponent } = {
  workspaces: {
    title: 'Workspaces',
    url: '/workspaces',
    order: 10,
    type: ProductComponentType.Workspaces,
    theme: 'teal',
  },
  decks: {
    title: 'Decks',
    order: 1,
    type: ProductComponentType.Decks,
    url: '/decks/list',
    theme: 'olive',
  },
  studyschedule: {
    title: 'Study Schedule',
    type: ProductComponentType.StudySchedule,
    order: 100,
    url: '/schedule',
    theme: 'green',
  },
  videos: {
    title: 'Video Topics',
    type: ProductComponentType.Videos,
    order: 1000000,
    theme: 'blue',
    url: '',
  },
  flashcards: {
    title: 'Flashcards',
    type: ProductComponentType.Flashcards,
    order: 10000,
    url: '/flashcards',
    theme: 'olive',
    inEnglish: true,
  },
  qbank: {
    title: 'QBank',
    type: ProductComponentType.Qbank,
    order: 1000,
    url: '/qbank',
    theme: 'purple',
  },
  playlists: {
    title: 'Playlists',
    type: ProductComponentType.Playlists,
    url: '/playlist',
    order: 999999, // Sort below videos
  },
  analytics: {
    title: 'Admin Analytics',
    url: '/analytics/summary',
    type: ProductComponentType.Analytics,
    order: 1,
  },
};
